export default __webpack_public_path__ + "2022_03_01_16_57/media/download-qrcode.671fb836.png";